// extracted by mini-css-extract-plugin
export default {"closeSize":"VideoModal_closeSize__BdOpx","modal_adjust":"VideoModal_modal_adjust__ayxAm"};